<template>
  <BaseModal
    :id="id"
    class="editorial-upload-info"
    :heading="$t('Upload Files and Create Assets')"
    :on-confirm="next"
    :confirm-text="$t('Next')"
    :hide-cancel-button="true"
  >
    <div class="editorial-upload-info__content comet-long-form-text">
      <!-- eslint-disable max-len -->
      <p>
        {{ $t('When uploading media to a Studio Creation that will be placed in Discovery Education services, you will be adding your media as an Asset through our content management system. Read the directions below before proceeding.') }}
      </p>
      <p>
        {{ $t('Instructions:') }}
      </p>
      <ol class="editorial-upload-info__instructions">
        <li>{{ $t("Once you have your asset looking the way you want it in Studio, click the asset and then click the 'Edit' pencil.") }}</li>
        <li>{{ $t("Click the 'View in Atlas' button at the top of the mini-menu. You will be taken to our CMS in a new tab.") }}</li>
        <li>{{ $t("Once in our content management system, make sure the asset is set to 'Active.'") }}</li>
        <li>{{ $t('Add any Media Packs, or metadata like Title and/or Description that is needed so our users can see this asset in the Board or Slideshow properly.') }}</li>
      </ol>
      <p>
        {{ $t("You're all set! The Publishing Queue for Assets runs nightly at 7:15pm EST.") }}
      </p>
      <p>
        {{ $t("Click 'Next' to start uploading assets.") }}
      </p>
      <!-- eslint-enable max-len -->
    </div>
  </BaseModal>
</template>

<script>
import { mapActions } from 'pinia';
import BaseModal from '@/components/modals/BaseModal.vue';
import * as types from '@/lib/constants/store';
import {
  useModalStore,
} from '@/stores';

export default {
  name: 'EditorialUploadInfo',
  components: {
    BaseModal,
  },
  props: {
    id: {
      type: String, // used for opening and closing modal
      required: true,
    },
    options: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  methods: {
    ...mapActions(useModalStore, [
      types.CLOSE_MODAL,
      types.OPEN_MODAL,
    ]),
    next() {
      this[types.CLOSE_MODAL]({ id: this.id });
      this[types.OPEN_MODAL]({
        type: 'EditorialUploadModal',
        allowMultiple: this.options.allowMultiple,
        canvasName: this.options.canvasName,
        initFiles: this.options.initFiles,
        moduleToReplace: this.options.moduleToReplace,
        onConfirm: this.options.onConfirm,
      });
    },
  },
};
</script>

<style lang="stylus">
.editorial-upload-info {
  .comet-modal {
    &__inner {
      max-height: "calc(100vh - %s)" % $nebula-space-6x;
    }

    &__content {
      height: $nebula-space-4x;
      overflow: visible;
    }
  }

  &__content {
    max-height: calc(100vh - 220px);
    overflow: auto;
  }

  &__content ol {
    margin-bottom: $nebula-space-1x;
  }

  &__content p {
    margin-bottom: $nebula-space-1x;

    &:last-of-type {
      margin: 0;
    }
  }
}
</style>
